module.exports = __webpack_public_path__ + "0af5d249/img/product-icon-grey.b248963c.svg";